import firebase from "firebase";
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyAUmljIAo8BjJErvwFrh65PbmC4yK_-B5M",
  authDomain: "deltaposapp.firebaseapp.com",
  databaseURL: "https://deltaposapp.firebaseio.com",
  projectId: "deltaposapp",
  storageBucket: "deltaposapp.appspot.com",
  messagingSenderId: "431060165188",
  appId: "1:431060165188:web:13819f03eb1eae6d815211",
  measurementId: "G-7KD4FY8M3B"
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const storageRef = storage.ref();
const auth = firebase.auth();

// firebase collections
// const categories = db.collection('categories');

export {
  firebase,
  db,
  storage,
  storageRef,
  auth
  // categories
}
